import React, { Component } from 'react';
import axios from 'axios';
import { injectIntl } from 'react-intl';

class Homepage extends Component {
  constructor(props) {
    super(props);
    const { staticContext } = props;
    let initialData = {};
    if (staticContext && staticContext?.data) {
      initialData = staticContext.data;
    } else if (typeof window !== 'undefined' && window.__ROUTE_DATA__) {
      initialData = window.__ROUTE_DATA__;
      delete window.__ROUTE_DATA__;
    }

    this.state = initialData;
  }

  componentDidUpdate(prevProps) {
    const { props } = this;
    if (prevProps.match !== props.match || prevProps.intl.locale !== props.intl.locale) {
      axios.post(`${process.env.REACT_APP_API_PREFIX}/get-callback`, {
        callback: '@Callbacks/getHomePageData',
        currentRoute: props.match,
        currentLanguage: props.intl.locale,
      }).then((response) => {
        this.setState(response.data);
        return response;
      }).catch(() => {
        this.setState({});
      });
    }
  }

  render() {
    const { links } = this.state;

    return (
      <div className="py-l l:py-xl wrapper wrapper bg-brand--white">
        <h2 className="block__title">React routes</h2>
        <div className="content-block__description">
          {links && links.map((link) => (
            <div key={`route-${link.routeName}`}>
              <a href={link.url}>{link.routeName}</a>
            </div>
          ))}
          {!links && (<div>Can not find any information on app routes for current language.</div>)}
        </div>
      </div>
    );
  }
}

export default injectIntl((Homepage));
